const SelfServeRecipientBuilderEnum = {
  SELF_SERVE_RECIPIENT_BUILDER_SECTION_DATA_GET_SUCCESS: 'SELF_SERVE_RECIPIENT_BUILDER_SECTION_DATA_GET_SUCCESS',
  SELF_SERVE_RECIPIENT_BUILDER_SECTION_DATA_GET_REQUEST: 'SELF_SERVE_RECIPIENT_BUILDER_SECTION_DATA_GET_REQUEST',
  SELF_SERVE_RECIPIENT_BUILDER_SECTION_DATA_GET_FAILURE: 'SELF_SERVE_RECIPIENT_BUILDER_SECTION_DATA_GET_FAILURE',
  SELF_SERVE_RECIPIENT_BUILDER_SET_FINISHED: 'SELF_SERVE_RECIPIENT_BUILDER_SHARE_SET_FINISHED',
  SELF_SERVE_RECIPIENT_BUILDER_SET_FINISHED_FAILURE: 'SELF_SERVE_RECIPIENT_BUILDER_SHARE_SET_FINISHED_FAILURE',
  SELF_SERVE_RECIPIENT_BUILDER_DOCUMENT_SHARE_ASSOCIATE_SUCCESS: 'SELF_SERVE_RECIPIENT_BUILDER_DOCUMENT_SHARE_ASSOCIATE_SUCCESS',
  SELF_SERVE_RECIPIENT_BUILDER_DOCUMENT_SHARE_ASSOCIATE_FAILURE: 'SELF_SERVE_RECIPIENT_BUILDER_DOCUMENT_SHARE_ASSOCIATE_FAILURE',
  SELF_SERVE_RECIPIENT_BUILDER_HIGHLIGHT_FIELD: 'SELF_SERVE_RECIPIENT_BUILDER_HIGHLIGHT_FIELD',
};

export default SelfServeRecipientBuilderEnum;



// WEBPACK FOOTER //
// ./src-react/SelfServeRecipientBuilder/SelfServeRecipientBuilderConstants.jsx